// extracted by mini-css-extract-plugin
export default {"mobile-items":"styles_mobile-items__GejRV","item":"styles_item__PsmEn","surprise":"styles_surprise__ZDPlP"};